import { render, staticRenderFns } from "./IndicatorSetting.vue?vue&type=template&id=f3ddc87e&scoped=true"
import script from "./IndicatorSetting.vue?vue&type=script&lang=js"
export * from "./IndicatorSetting.vue?vue&type=script&lang=js"
import style0 from "./IndicatorSetting.vue?vue&type=style&index=0&id=f3ddc87e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ddc87e",
  null
  
)

export default component.exports